import IconButton from '@mui/material/IconButton';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import BrightnessAutoIcon from '@mui/icons-material/BrightnessAuto';
import { useColorScheme } from '@mui/material/styles';

/**
 * ColorModeToggle — standalone dark/light mode toggle button.
 * Uses MUI v7 useColorScheme hook (requires ThemeProvider with colorSchemes).
 * Shows LightMode icon in dark mode (click to go light), DarkMode icon in light mode (click to go dark).
 * Handles SSR/initial render where mode is undefined by showing a neutral icon.
 */
export default function ColorModeToggle() {
  const { mode, setMode } = useColorScheme();

  const handleToggle = () => {
    setMode(mode === 'dark' ? 'light' : 'dark');
  };

  const icon =
    mode === 'dark' ? (
      <LightModeIcon />
    ) : mode === 'light' ? (
      <DarkModeIcon />
    ) : (
      <BrightnessAutoIcon />
    );

  return (
    <IconButton
      onClick={handleToggle}
      aria-label="toggle color mode"
      sx={(t) => ({
        color: 'text.primary',
        ...t.applyStyles('light', {
          color: 'grey.700',
        }),
      })}
    >
      {icon}
    </IconButton>
  );
}
